import { useAuthStore } from '@/stores/auth.js'

export const useCheckPermission = (permiso) => {

  const authStore = useAuthStore()

  const hasPermission = authStore.permisos.includes(permiso);
  return {
    hasPermission
  }
}
